import client from '../base-api';

const serviceURL = '/billing';

const billingService = {
    // 1. EXISTED BILLS
    // Lists
    getLatestBills(filterData: any) {
        return client.get(`${serviceURL}/latest-bills`, {params: filterData});
    },
    getArchivedBills(filterData: any) {
        return client.get(`${serviceURL}/archived-bills`, {params: filterData});
    },
    getBillDetails(id: number) {
        return client.get(`${serviceURL}/details/${id}`);
    },


    // Cancellation
    privateCoachingBillCancellation(id: number) {
        return client.put(`${serviceURL}/private-coaching/cancellation-bill/${id}`);
    },
    groupCoachingBillCancellation(id: number) {
        return client.put(`${serviceURL}/group-coaching/cancellation-bill/${id}`);
    },
    socioTherapyCoachingBillCancellation(id: number) {
        return client.put(`${serviceURL}/socio-therapy-coaching/cancellation-bill/${id}`);
    },
    assistedLivingCoachingBillCancellation(id: number) {
        return client.put(`${serviceURL}/assisted-living-coaching/cancellation-bill/${id}`);
    },
    caseManagementCoachingBillCancellation(id: number) {
        return client.put(`${serviceURL}/case-management-coaching/cancellation-bill/${id}`);
    },
    privateLearningCoachingBillCancellation(id: number) {
        return client.put(`${serviceURL}/private-learning-coaching/cancellation-bill/${id}`);
    },
    specialCaseBillCancellation(id: number) {
        return client.put(`${serviceURL}/special-case/cancellation-bill/${id}`);
    },


    // 2. CREATING BILLS
    getPrivateCoachingPreviewList(filterData: any) {
        return client.get(`${serviceURL}/private-coaching/preview-list`, {params: filterData});
    },
    createPrivateCoachingBill(coachingIds: any) {
        return client.post(`${serviceURL}/private-coaching/create-bill`, coachingIds);
    },

    getGroupCoachingPreviewList(filterData: any) {
        return client.get(`${serviceURL}/group-coaching/preview-list`, {params: filterData});
    },
    createGroupCoachingBill(coachingIds: any) {
        return client.post(`${serviceURL}/group-coaching/create-bill`, coachingIds);
    },

    getAssistedLivingCoachingPreviewList(filterData: any) {
        return client.get(`${serviceURL}/assisted-living-coaching/preview-list`, {params: filterData});
    },
    createAssistedLivingCoachingBill(coachingIds: any) {
        return client.post(`${serviceURL}/assisted-living-coaching/create-bill`, coachingIds);
    },

    getSocioTherapyCoachingPreviewList(filterData: any) {
        return client.get(`${serviceURL}/socio-therapy-coaching/preview-list`, {params: filterData});
    },
    createSocioTherapyCoachingBill(coachingIds: any) {
        return client.post(`${serviceURL}/socio-therapy-coaching/create-bill`, coachingIds);
    },

    getCaseManagementCoachingPreviewList(filterData: any) {
        return client.get(`${serviceURL}/case-management-coaching/preview-list`, {params: filterData});
    },
    createCaseManagementCoachingBill(coachingIds: any) {
        return client.post(`${serviceURL}/case-management-coaching/create-bill`, coachingIds);
    },

    getPrivateLearningCoachingPreviewList(filterData: any) {
        return client.get(`${serviceURL}/private-learning-coaching/preview-list`, {params: filterData});
    },
    createPrivateLearningCoachingBill(coachingIds: any) {
        return client.post(`${serviceURL}/private-learning-coaching/create-bill`, coachingIds);
    },

    createSpecialCaseBill(data: any) {
        return client.post(`${serviceURL}/special-case/create-bill`, data);
    },


    // 3. BILL CORRECTION
    socioTherapyCoachingBillCorrection(formData: any) {
        return client.post(`${serviceURL}/socio-therapy-coaching-bill-correction`, formData);
    },


}

export default billingService;